import styled from 'styled-components';
import { Typography } from '~/ui/components';
import { themeToggleColor } from '~/common/utils/theme';

export const LocationWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: flex-start;
`;

export const LocationInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const LocationName = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'p',
  weight: 600,
  color: themeToggleColor(theme, 'element.primary', { dark: 'element.invert' }),
}))`
  margin: 0;
`;

export const LocationAddress = styled(Typography).attrs(({ theme }) => ({
  type: 'caption',
  element: 'p',
  weight: 400,
  color: themeToggleColor(theme, 'element.secondary', { dark: 'element.secondary' }),
}))`
  margin: 0;
`;

export const MapLink = styled.a`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => themeToggleColor(theme, 'brand.primary', { dark: 'brand.primary' })};
  text-decoration: underline;
  cursor: pointer;
  margin-top: 2px;
`;
